/**
 *  AudioManager
 *
 *  Created by Legman on 25/02/2016.
 *
 */

"use strict";

var Audio                   = require("./Audio");
var AudioParams             = require("./AudioParams");

function AudioManager() {
    /**
     * @type {object}
     * @private
     */
    this._cache = {};

    /**
     * @type {Howl}
     * @private
     */
    this._music = null;

    /**
     * @type {boolean}
     * @private
     */
    this._isMuted = false;

    this.audioBlocked = true;

    var hidden;
    "undefined" != typeof document.hidden ? (hidden = "hidden",
        this.visibilityChange = "visibilitychange")     : "undefined" != typeof document.mozHidden  ? (hidden = "mozHidden",
        this.visibilityChange = "mozvisibilitychange")  : "undefined" != typeof document.msHidden   ? (hidden = "msHidden",
        this.visibilityChange = "msvisibilitychange")   : "undefined" != typeof document.webkitHidden && (hidden = "webkitHidden",
        this.visibilityChange = "webkitvisibilitychange");

    document.addEventListener(this.visibilityChange, function(){
        document[hidden] ? Howler.volume(0) : Howler.volume(1);
    }, false);

}
module.exports = AudioManager;

/**
 * @param {!Array.<string>} sounds
 * @param {!Array.<string>} extensions
 * @param {string=} basePath
 */
AudioManager.prototype.addSounds = function(sounds, extensions, basePath) {
    basePath = basePath || "";

    var howl, name, url, urls, extension, i, j;
    for (i = 0; i < sounds.length; ++ i) {
        url     = basePath + sounds[i].url;
        url     = url.split("/");
        name    = sounds[i].name;
        //name    = url.length > 1 ? sounds[i] : url[url.length - 1];

        urls = [];
        for (j = 0; j < extensions.length; ++ j) {
            extension = extensions[j];
            urls.push(url.join("/") + extension);
        }
        howl = new Howl({
            src: urls,
            volume: 1.0,
            loop: false,
            autoplay: false
        });
        howl.on('play', function(){
            this.audioBlocked = false;
        }.bind(this));
        howl.name           = name;
        this._cache[name]  = howl;
    }
};

/**
 * @param {!Array.<string>} sounds
 */
AudioManager.prototype.removeSounds = function(sounds) {
    var name, n, howl;
    for (var i = 0; i < sounds.length; ++ i) {
        name = sounds[i];
        for (n in this._cache) {
            if (this._cache.hasOwnProperty(key)) {
                howl = this._cache[key];
                if (howl.name == n) {
                    howl.unload();
                    delete this._cache[name];
                    break;
                }
            }
        }
    }
};

/**
 * @param {!string | Array.<string>} name
 * @param {AudioParams=} params
 * @returns {Audio}
 */
AudioManager.prototype.playSound = function(name, params)
{
    params = params || new AudioParams();

    if(name.indexOf('vo/') > -1)
    {
        if(this.stopVO() === false)
        {
            return;
        }
    }

    var id = -1;

    if (typeof name !== "string") {
        name = name[Math.floor(Math.random() * name.length)];
    }

    var howl = this._cache[name];
    if (!howl) {
        console.warn("Could not find sound - " + name);
        return id;
    }

    id = howl.play();
    howl.volume(params.volume, id);
    howl.loop(params.loop, id);
	
    // callback
    howl.__onend = function() {
        params.callback && params.callback.call(params.scope);
    };
    howl.on("end", howl.__onend);	

    var audio = new Audio();
    audio.id = id;
    audio.howl = howl;
    return audio;
};

/**
 * @param {!string | Array.<string>} name
 * @param {AudioParams=} params
 * @returns {Audio}
 */
AudioManager.prototype.playMusic = function(name, params) {
    params = params || new AudioParams();

    var id = -1;

    if (typeof name !== "string") {
        name = name[Math.floor(Math.random() * name.length)];
    }

    // skip if no change
    if (this._music && this._music.name == name) {
        return this._music;
    }

    var howl = this._cache[name];
    if (!howl) {
        console.warn("Could not find music - " + name);
        return null;
    }

    // callback
    howl.__onend = function() {
        params.callback && params.callback.call(params.scope);
    };
    howl.on("end", howl.__onend);

    if (p3.Device && p3.Device.isAndroidStockBrowser) {
        howl.buffer = true;
    }

    id = howl.play();
    howl.volume(params.volume, id);
    howl.loop(true, id);

    var audio = new Audio();
    audio.id = id;
    audio.howl = howl;

    if (params.fadeIn > 0.0) {
        this.fadeIn(audio, params.fadeIn);
    }

    this._music = audio;
    return audio;

    /*
    if (params.fadeIn > 0.0) {
        if (this._music && this._music.name != name) {
            this.fadeOut(this._music, params.fadeIn, function(howl) {
                howl.stop();
            }, this);
        }
        this.fadeIn(howl, params.fadeIn);
    } else {
        this._music && this.stopMusic();
        howl.play();
    }
    this._music = howl;
    return howl;
    */
};

/**
 * @param {!string} name
 * @param {number=} id
 */
AudioManager.prototype.stopSound = function(name, id)
{
	try
	{
		var howl = this._cache[name];
		if(!howl)
		{
			console.warn("Could not find sound - " + name);
			return;
		}
		howl.stop(id);
	}
	catch(e)
	{
		console.error(e);
	}
};

/**
 * @param {!string} name
 * @param {number=} id
 */
AudioManager.prototype.pauseSound = function(name, id)
{
	try
	{
		var howl = this._cache[name];
		if(!howl)
		{
			console.warn("Could not find sound - " + name);
			return;
		}
		howl.pause(id);
	}
	catch(e)
	{
		console.error(e);
	}
};


/**
 * @param {!string} name
 * @param {number=} id
 */
AudioManager.prototype.resumeSound = function(name, id)
{
	try
	{
		var howl = this._cache[name];
		if(!howl)
		{
			console.warn("Could not find sound - " + name);
			return;
		}
		howl.play(id);
	}
	catch(e)
	{
		console.error(e);
	}
};

/**
 * @param {!string} name
 * @param {number=} id
 */
AudioManager.prototype.fadeSound = function(name, id, volumeStart, volumeEnd, time)
{
	try
	{
		var howl = this._cache[name];
		if(!howl)
		{
			console.warn("Could not find sound - " + name);
			return;
		}
		howl.fade(volumeStart, volumeEnd, time * 1000, id);
	}
	catch(e)
	{
		console.error(e);
	}
};



/**
 * @param {string=} name
 */
AudioManager.prototype.stopMusic = function(name)
{
	if(!this._music) return;

    var name = name || this._music.name;
    if (this._music.name == name)
	{
        this._music.__onend && this._music.off("end", this._music.__onend);
        this._music.howl.stop();
        this._music = null;
    }
};

/**
 * @param {!boolean} value
 */
AudioManager.prototype.mute = function(value) {
    this._isMuted = value;
    if (this._isMuted) {
        Howler.mute(true);
    } else {
        Howler.mute(false);
    }
    console.log('soundManager: ', this._isMuted);
};

/**
 * @param {!Audio} audio
 * @param {number=} duration
 * @param {function=} callback
 * @param {*=} scope
 */
AudioManager.prototype.fadeIn = function(audio, duration, callback, scope) {
    duration = duration || 1.0;

    var volume = audio.howl.volume(audio.id);
    audio.howl.volume(0.0, audio.id);
    audio.__volume = 0.0;

    TweenMax.killTweensOf(audio);
    TweenMax.to(audio, duration, {
        __volume: volume,
        ease: Power1.easeInOut,
        onUpdate: function() {
            audio.howl.volume(audio.__volume, audio.id);
        },
        onUpdateScope: this,
        onComplete: callback,
        onCompleteParams: [audio],
        onCompleteScope: scope
    });
};

/**
 * @param {!Howl} howl
 * @param {number=} duration
 * @param {function=} callback
 * @param {*=} scope
 */
AudioManager.prototype.fadeOut = function(howl, duration, callback, scope) {



    // todo FIX THIS
    // todo FIX THIS
    // todo FIX THIS
    // todo FIX THIS



    duration = duration || 1.0;
    howl.__volume = howl._volume;

    TweenMax.killTweensOf(howl);
    TweenMax.to(howl, duration, {
        __volume: 0.0,
        ease: Power1.easeInOut,
        onUpdate: function() {
            howl.volume(howl.__volume);
        },
        onUpdateScope: this,
        onComplete: callback,
        onCompleteParams: [howl],
        onCompleteScope: scope
    });
};

/**
 * @param {!Audio} audio
 * @param {!*} object
 * @param {!Camera} camera
 * @param {number=} min
 * @param {number=} max
 */
AudioManager.prototype.setAudioPos3D = function(audio, object, camera, min, max) {
    min = min || 0.0;
    max = max || 320.0;

    var layer = camera.findLayerForObject(object);
    var x = object.x * (1.0 / layer.parallax.x);
    var sign = (x - camera.position.x);
    sign = sign / Math.abs(sign);

    if (sign == -1) x = Math.min(0.0, ((x + min) - camera.position.x) / (max - min));
    else if (sign == 1) x = Math.max(0.0, ((x - min) - camera.position.x) / (max - min));

    audio.howl.pos(x, 0.0, 0.0, audio.id);
};

/**
 * @param {!Audio} audio
 * @param {!*} object
 * @param {!Camera} camera
 * @param {number=} min
 * @param {number=} max
 */
AudioManager.prototype.setAudioPosStereo = function(audio, object, camera, min, max) {
    min = min || 0.0;
    max = max || 320.0;

    var layer = camera.findLayerForObject(object);
    var x = object.x * (1.0 / layer.parallax.x);
    var sign = (x - camera.position.x);
    sign = sign / Math.abs(sign);

    x = Math.max(0.0, Math.abs((x - min) - camera.position.x) / (max));
    x = Math.max(0.0, Math.min(1.0, 1.0 + (1.0 - x)));

    audio.howl.volume(x, audio.id);

    x = object.x * (1.0 / layer.parallax.x);

    if (sign == -1) x = Math.min(0.0, ((x + min) - camera.position.x) / (max - min));
    else if (sign == 1) x = Math.max(0.0, ((x - min) - camera.position.x) / (max - min));

    x = Math.max(-1.0, Math.min(1.0, x));
    audio.howl.stereo(x, audio.id);
};

Object.defineProperty(AudioManager.prototype, "isMute", {
    /**
     * @returns {!boolean}
     */
    get: function() {
        return this._isMuted;
    }
});


AudioManager.prototype.hasSound = function()
{
    if(this._cache[name])
    {
        return true;
    }
    return false;
};

AudioManager.prototype.stopAllSounds = function()
{
    for(var i in this._cache)
    {
        this._cache[i].stop();
    }
};

AudioManager.prototype.stopVO = function()
{
    for(var i in this._cache)
    {
        if(this._cache[i].playing(i))
        {
            if(i.indexOf('challenges') > -1 || i.indexOf('upgrades') > -1) //Important VO playing that shouldn't be overridden
            {
                return false;
            }
            else if(i.indexOf('vo/') > -1)
            {
                this._cache[i].stop();
            }
        }
    }
};